import React from 'react';
import { ExtendedFilterType } from '../types';
import { DateRangeSelector, DateRangeType } from '@cokitchen/cokitchen-components';

type TripTabProps = {
  list: ExtendedFilterType[];
  active: ExtendedFilterType;
  setActive: (item: ExtendedFilterType) => void;
  smallText?: boolean;
  dateRange: DateRangeType;
  setDateRange: (arg: DateRangeType) => void;
};
export const TripTab: React.FC<TripTabProps> = ({
  list,
  active,
  setActive,
  smallText,
  dateRange,
  setDateRange
}) => {
  const navStyles = {
    active: 'border-b border-b-[4px] border-b-[#E60A2B] mb-0 text-[#1A1A1A]',
    inactive: 'text-[#858585]'
  };
  return (
    <div className='flex max-md:flex-col items-end gap-4 justify-between'>
      <div className='flex justify-start grow no-scroll-bar w-full border-b border-[#DCE2EA]'>
        {list
          .sort((a, b) => a.localeCompare(b))
          .map((item, index) => (
            <p
              key={index}
              onClick={() => setActive(item)}
              className={`flex mr-6 last:mr-0 cursor-pointer py-4 whitespace-nowrap capitalize ${
                smallText ? 'text-sm' : 'text-base'
              } ${item === active ? navStyles.active : navStyles.inactive}`}>
              {item} {index !== 0 && 'Trips'}
            </p>
          ))}
      </div>
      <DateRangeSelector defaultRange={dateRange.range} onChange={setDateRange} />
    </div>
  );
};
